import React, { useState, useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import "./FAQ.css";

const FAQ = () => {
  const [faq1Visible, setFaq1Visible] = useState(false);
  const [faq5Visible, setFaq5Visible] = useState(false);
  const [faq4Visible, setFaq4Visible] = useState(false);
  const [faq3Visible, setFaq3Visible] = useState(false);
  const [faq2Visible, setFaq2Visible] = useState(false);
  const [faq6Visible, setFaq6Visible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#Terms-and-Privacy") {
      document
        .getElementById("Terms-and-Privacy")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location]);

  return (
    <div className="faqfaq8 thq-section-padding">
      <div className="faq-max-width thq-section-max-width">
        <div className="faq-container10 thq-flex-column">
          <div className="faq-section-title thq-flex-column">
            <h2 className="faq-text10 thq-heading-2">
              <Fragment>
                <span className="faq-text26">FAQs</span>
              </Fragment>
            </h2>
          </div>
          <div className="faq-list thq-flex-column">
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq1">
              <div
                onClick={() => setFaq1Visible(!faq1Visible)}
                className="faq-trigger1"
              >
                <p className="faq-faq1-question1 thq-body-large">
                  <Fragment>
                    <span className="faq-text27">What is Coin Basis?</span>
                  </Fragment>
                </p>
                <div className="faq-icons-container1">
                  {!faq1Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon10">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq1Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon12">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq1Visible && (
                <div className="faq-container13">
                  <span className="thq-body-small">
                    Coin Basis is a software platform that calculates the cost
                    basis for cryptocurrency transactions and generates detailed
                    reports for tax preparation. It helps users organize and
                    understand their taxable events, including short- and
                    long-term gains, in an easy-to-use format.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq2">
              <div
                onClick={() => setFaq2Visible(!faq2Visible)}
                className="faq-trigger2"
              >
                <p className="faq-faq2-question1 thq-body-large">
                  <Fragment>
                    <span className="faq-text22">
                      How does Coin Basis calculate cost basis?
                    </span>
                  </Fragment>
                </p>
                <div className="faq-icons-container2">
                  {!faq2Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon14">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq2Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon16">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq2Visible && (
                <div className="faq-container16">
                  <span className="thq-body-small">
                    We use the FIFO (First In, First Out) method to calculate
                    the cost basis of your cryptocurrency transactions, which is
                    the IRS's standard method unless you specify otherwise. Our
                    algorithm analyzes your transaction data to determine the
                    taxable events and outputs them in a detailed CSV report.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq3">
              <div
                onClick={() => setFaq3Visible(!faq3Visible)}
                className="faq-trigger3"
              >
                <p className="faq-faq2-question2 thq-body-large">
                  <Fragment>
                    <span className="faq-text24">
                      Does Coin Basis file my taxes for me?
                    </span>
                  </Fragment>
                </p>
                <div className="faq-icons-container3">
                  {!faq3Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon18">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq3Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon20">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq3Visible && (
                <div className="faq-container19">
                  <span className="thq-body-small">
                    No, Coin Basis does not file taxes. Our platform provides
                    calculations and reports that you can use to prepare your
                    tax filing or share with a tax professional. We recommend
                    consulting with a licensed tax advisor to ensure compliance
                    with applicable regulations.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq4">
              <div
                onClick={() => setFaq4Visible(!faq4Visible)}
                className="faq-trigger4"
              >
                <p className="faq-faq2-question3 thq-body-large">
                  <Fragment>
                    <span className="faq-text21">
                      Can I link my wallet addresses using Coin Basis?
                    </span>
                  </Fragment>
                </p>
                <div className="faq-icons-container4">
                  {!faq4Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon22">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq4Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon24">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq4Visible && (
                <div className="faq-container22">
                  <span className="thq-body-small">
                    At the moment, Coin Basis only supports manual CSV uploads.
                    Support for blockchain syncing will be coming in a future
                    update.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq51">
              <div
                onClick={() => setFaq5Visible(!faq5Visible)}
                className="faq-trigger5"
              >
                <p className="faq-faq1-question2 thq-body-large">
                  <Fragment>
                    <span className="faq-text20">
                      Can I use Coin Basis for prior tax years?
                    </span>
                  </Fragment>
                </p>
                <div className="faq-icons-container5">
                  {!faq5Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon26">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq5Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon28">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq5Visible && (
                <div className="faq-container25">
                  <span className="thq-body-small">
                    Currently, Coin Basis is optimized for the 2024 tax year,
                    but it can also handle prior year transactions if your data
                    is formatted correctly. This flexibility allows you to
                    retroactively calculate cost basis for earlier years.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
            <div className="faq-faq52">
              <div
                onClick={() => setFaq6Visible(!faq6Visible)}
                className="faq-trigger6"
              >
                <p className="faq-faq1-question3 thq-body-large">
                  <Fragment>
                    <span className="faq-text28">
                      Is Coin Basis only for U.S. Customers?
                    </span>
                  </Fragment>
                </p>
                <div className="faq-icons-container6">
                  {!faq6Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon30">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq6Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq-icon32">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq6Visible && (
                <div className="faq-container28">
                  <span className="thq-body-small">
                    While Coin Basis is optimized for U.S. tax laws and uses
                    FIFO as the default calculation method, users from other
                    countries can also use our platform to calculate cost basis
                    and generate reports. However, non-U.S. users should verify
                    local tax compliance requirements.
                  </span>
                </div>
              )}
            </div>
            <div className="thq-divider-horizontal"></div>
          </div>
        </div>
        <div className="faq-content1 thq-flex-column">
          <div className="faq-content2">
            <h2 className="faq-text18 thq-heading-2">
              <Fragment>
                <span className="faq-text25">Still have a question?</span>
              </Fragment>
            </h2>
          </div>
          <a
            href="mailto:support@coinbasis.tech?subject="
            className="faq-link thq-button-filled"
          >
            <span className="faq-text23">Email us</span>
          </a>
        </div>
        <div className="Terms-and-Privacy" id="Terms-and-Privacy">
          <Fragment>
            <br></br>
            <br></br>
            <br></br>
            <span>
              <strong>
                Terms and Conditions, Privacy Statement and Refund Policy
              </strong>
            </span>
          </Fragment>
        </div>
        <div className="content-list5-container thq-section-padding left-align">
          <Fragment>
            <span className="content-list5-text100">
              <span>
                <strong>Terms & Conditions</strong>
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>1. Agreement to Terms</strong>
              </span>
              <br></br>
              <span>
                By accessing or using the Coin Basis platform (&quot;the
                Service&quot;), you agree to comply with and be bound by these
                Terms of Service (&quot;Terms&quot;). If you do not agree, do
                not use the Service.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>2. Eligibility</strong>
              </span>
              <br></br>
              <span>
                You must be at least 18 years old and capable of forming a
                legally binding contract to use the Service. By using the
                Service, you represent that you meet these requirements.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>3. Description of the Service</strong>
              </span>
              <br></br>
              <span>
                Coin Basis provides software designed to calculate the cost
                basis of cryptocurrency transactions and generate reports for
                informational purposes only. The Service does not provide tax,
                legal, or financial advice and is not a substitute for
                consulting licensed professionals.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>4. User Responsibilities</strong>
              </span>
              <br></br>
              <span>
                Accurate Data Input: You are responsible for ensuring the
                accuracy and completeness of the data you upload to the Service.
              </span>
              <br></br>
              <br></br>
              <span>
                Compliance: You are responsible for complying with all
                applicable laws and regulations when using the Service and
                filing your taxes.
              </span>
              <br></br>
              <br></br>
              <span>
                Prohibited Use: You agree not to use the Service for any
                unlawful purpose or in a manner that could damage, disable, or
                impair the Service.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>5. Intellectual Property</strong>
              </span>
              <br></br>
              <span>
                All content, features, and functionality of the Service,
                including but not limited to the software, text, graphics, and
                logos, are the property of Coin Basis and are protected by
                intellectual property laws. You may not copy, distribute, or
                reverse-engineer any part of the Service.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>6. Disclaimer of Warranties</strong>
              </span>
              <br></br>
              <span>
                The Service is provided &quot;as is&quot; without warranties of
                any kind, either express or implied, including but not limited
                to merchantability, fitness for a particular purpose, or
                non-infringement. Coin Basis does not guarantee that the Service
                will be error-free or that reports generated will be accurate or
                complete.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>7. Limitation of Liability</strong>
              </span>
              <br></br>
              <span>
                To the fullest extent permitted by law, Coin Basis and its
                developers shall not be liable for any indirect, incidental, or
                consequential damages arising from your use of the Service.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>8. Modifications to the Service</strong>
              </span>
              <br></br>
              <span>
                Coin Basis reserves the right to modify, suspend, or discontinue
                the Service at any time, with or without notice.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>9. Termination</strong>
              </span>
              <br></br>
              <span>
                Coin Basis may suspend or terminate your access to the Service
                at its sole discretion, with or without cause, and without prior
                notice.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>10. Subscription Model</strong>
              </span>
              <br></br>
              <span>
                Coin Basis offers a subscription model for accessing premium
                features. Subscriptions are billed annually through Stripe. By
                subscribing, you agree to Stripe's terms of service and privacy
                policy.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>11. Governing Law</strong>
              </span>
              <br></br>
              <span>
                These Terms are governed by the laws of the State of Illinois,
                without regard to its conflict of law principles.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>12. Contact Information</strong>
              </span>
              <br></br>
              <span>
                For questions about these Terms, contact us at
                support@coinbasis.tech
              </span>
            </span>
          </Fragment>
          <Fragment>
            <div className="left-align">
              <span className="content-list5-text161"></span>
              <br></br>
              <br></br>
              <br></br>
              <span>
                <strong>Privacy Statement & Cookies Policy</strong>
              </span>
              <br></br>
              <br></br>
              <span className="left-align">
                <strong>1. Introduction</strong>
              </span>
              <br></br>
              <span>
                Coin Basis (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;)
                is committed to protecting your privacy. This Privacy Statement
                explains how we collect, use, and share information when you use
                our Service.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>2. Information We Collect</strong>
              </span>
              <br></br>
              <span>
                User-Provided Data: Transaction data you upload, including CSV
                files containing cryptocurrency transaction details.
              </span>
              <br></br>
              <br></br>
              <span>
                Automatically Collected Data: Technical information such as IP
                address, browser type, and usage statistics.
              </span>
              <br></br>
              <br></br>
              <span>
                Payment Information: We may collect payment details, but
                payments are processed by a third-party provider (e.g., Stripe,
                PayPal).
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>Cookies and Tracking Technologies</strong>
              </span>
              <br></br>
              <span>
                We use cookies and similar tracking technologies, including
                Google Analytics and Facebook Pixel, to:
              </span>
              <br></br>
              <br></br>
              <span>Understand user behavior and improve our services.</span>
              <br></br>
              <br></br>
              <span>Measure the effectiveness of our marketing campaigns.</span>
              <br></br>
              <br></br>
              <span>Provide insights into app and website performance.</span>
              <br></br>
              <br></br>
              <span>
                These technologies may collect information such as your IP
                address, device type, browser type, and pages visited. For more
                information about how Google and Facebook handle your data,
                please review their respective privacy policies.
              </span>
              <br></br>
              <br></br>
              <span>
                Google Analytics:{" "}
                <a href="https://policies.google.com/privacy">
                  Google Analytics Privacy Policy
                </a>
              </span>
              <br></br>
              <br></br>
              <span>
                Facebook Pixel:{" "}
                <a href="https://www.facebook.com/policy.php">
                  Facebook Data Policy
                </a>
              </span>
              <br></br>
              <br></br>
              <span>
                Your Choices: You can manage your cookie preferences using our
                cookie consent banner or by adjusting your browser settings to
                block or delete cookies. Additionally, you can opt-out of Google
                Analytics tracking by installing the{" "}
                <a href="https://tools.google.com/dlpage/gaoptout">
                  Google Analytics Opt-Out Browser Add-On
                </a>
                .
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>3. How We Use Your Information</strong>
              </span>
              <br></br>
              <span>
                To process and calculate cost basis for your transactions.
              </span>
              <br></br>
              <br></br>
              <span>To improve and personalize the Service.</span>
              <br></br>
              <br></br>
              <span>
                To communicate with you regarding updates or support requests.
              </span>
              <br></br>
              <br></br>
              <span>
                To process transactions, prevent fraud, and manage
                subscriptions.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>4. Sharing Your Information</strong>
              </span>
              <br></br>
              <span>
                We do not sell or share your personal information with third
                parties, except:
              </span>
              <br></br>
              <br></br>
              <span>
                As required by law or to comply with legal obligations.
              </span>
              <br></br>
              <br></br>
              <span>
                To trusted service providers who assist us in operating the
                Service, subject to confidentiality agreements.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>5. Data Security</strong>
              </span>
              <br></br>
              <span>
                We implement industry-standard security measures to protect your
                data. However, no system is completely secure, and we cannot
                guarantee the absolute security of your information.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>6. Data Retention</strong>
              </span>
              <br></br>
              <span>
                We retain your information only as long as necessary to provide
                the Service or as required by law.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>7. Your Rights</strong>
              </span>
              <br></br>
              <span>You have the right to:</span>
              <br></br>
              <br></br>
              <span>Access and review the data you have provided.</span>
              <br></br>
              <br></br>
              <span>
                Request deletion of your data, subject to legal requirements.
              </span>
              <br></br>
              <br></br>
              <span>Opt-out of receiving marketing communications.</span>
              <br></br>
              <br></br>
              <span>
                <strong>8. Subscription Model</strong>
              </span>
              <br></br>
              <span>
                Coin Basis offers a subscription model for accessing premium
                features. Subscriptions are billed annually through Stripe. By
                subscribing, you agree to Stripe's terms of service and privacy
                policy.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>9. Third-Party Payment Processors</strong>
              </span>
              <br></br>
              <span>
                Payments are handled by third-party services such as Stripe and
                PayPal. We recommend reviewing their privacy policies to
                understand how they handle your data.
              </span>
              <br></br>
              <br></br>
              <span>
                Stripe:{" "}
                <a href="https://stripe.com/privacy">Stripe Privacy Policy</a>
              </span>
              <br></br>
              <br></br>
              <span>
                PayPal:{" "}
                <a href="https://www.paypal.com/us/webapps/mpp/ua/privacy-full">
                  PayPal Privacy Policy
                </a>
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>10. Changes to This Privacy Statement</strong>
              </span>
              <br></br>
              <span>
                We may update this Privacy Statement from time to time. We will
                notify you of significant changes by posting a notice on our
                website or contacting you directly.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>11. Contact Information</strong>
              </span>
              <br></br>
              <span>
                For questions about this Privacy Statement, contact us at
                support@coinbasis.tech
              </span>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <span>
                <strong>Refund Policy</strong>
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>Eligibility for Refunds</strong>
              </span>
              <br></br>
              <span>
                1. We offer refunds within 30 days of the initial purchase for
                first-time customers who are unsatisfied with the service.
                Refunds are only available for first-time purchases and do not
                apply to renewals or subscription extensions.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>Non-Refundable Cases</strong>
              </span>
              <br></br>
              <span>
                2. Refunds are not available in the following cases: a.
                Customers who have already generated or downloaded their
                reports. b. Customers who have violated our Terms of Service. c.
                Customers who have made purchases with cryptocurrency.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>Refund Process</strong>
              </span>
              <br></br>
              <span>
                3. To request a refund, contact support@coinbasis.tech with
                your order details. Refund requests must be submitted within 30
                days of purchase. Approved refunds will be processed within 5-7
                business days via the original payment method.
              </span>
              <br></br>
              <br></br>
              <span>
                <strong>Changes to the Policy</strong>
              </span>
              <br></br>
              <span>
                4. Coin Basis reserves the right to modify this policy at any
                time. Any changes will be reflected on our website.
              </span>
            </div>
          </Fragment>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
